<template>
  <b-container>
    <input
      ref="file"
      type="file"
      style="display: none"
      @change="importTemplates"
    >
    <b-row class="mt-2 mb-0 mx-1 title-template">
      <h5>
        {{ getNameCurrProjectNavigation }} Templates
      </h5>
    </b-row>
    <b-row
      class="header-layout mt-2 ml-2"
      align-v="center"
    >
      <b-col
        v-if="multipSelVisible"
        cols="auto"
        class="px-0 py-0"
      >
        <b-button
          v-b-tooltip.hover.bottom="'Export Selected'"
          size="sm"
          @click="exportSelected"
        >
          <b-icon
            icon="box-arrow-up"
            aria-hidden="true"
          />
        </b-button>
      </b-col>
      <b-col
        v-if="singleSelVisible"
        cols="auto"
        class="pl-0 pr-0 py-0"
      >
        <b-button
          v-b-tooltip.hover.bottom="'Edit Selected'"
          size="sm"
          variant="info"
          @click="editSelected"
        >
          <b-icon
            icon="pencil"
            aria-hidden="true"
          />
        </b-button>
      </b-col>
      <b-col
        v-if="multipSelVisible"
        cols="auto"
        class="px-0 py-0"
      >
        <b-button
          v-b-tooltip.hover.bottom="'Remove Selected'"
          size="sm"
          variant="danger"
          @click="removeSelected"
        >
          <b-icon
            icon="trash"
            aria-hidden="true"
          />
        </b-button>
      </b-col>
      <b-col
        cols="auto"
        class="pl-0 py-0 mr-auto"
      >
        <b-button
          v-b-tooltip.hover.bottom="'Extract template from current report'"
          size="sm"
          variant="primary"
          @click="addNewTemplate"
        >
          <b-icon
            icon="bookmark-plus"
            aria-hidden="true"
          />
        </b-button>
      </b-col>
      <b-col
        cols="auto"
        class="pl-0 py-0 pr-2"
      >
        <b-button
          v-b-tooltip.hover.bottom="'Import templates'"
          size="sm"
          variant="primary"
          @click="$refs.file.click()"
        >
          <b-icon
            icon="box-arrow-in-down"
            aria-hidden="true"
          />
          Import
        </b-button>
      </b-col>
    </b-row>

    <b-row class="w-100">
      <InputDataTemplate
        :type="inputDataType"
        :elementid="elementEditionId"
        :data="paramsTable.data"
        :iddict="idTemplateDict"
        :importobj="newTemplate"
        @templateAdded="addLastTemplate"
        @templateImported="addImportTemplate"
        @changeTemplates="updateTemplate"
        @hideInput="hideInput"
      />
    </b-row>
    <b-row
      v-if="isLoading"
      align-h="center"
      class="w-100"
    >
      <b-spinner
        variant="success"
        style="width: 3rem; height: 3rem;"
        label="Large Spinner Text Centered"
      />
    </b-row>
    <b-row
      v-else
      class="mx-1 my-0 p-0"
      @mouseover="onHoverTable"
      @mouseleave="onLeave"
    >
      <vue-table-dynamic
        ref="tableTemplates"
        :params="paramsTable"
        class="m-0 p-0 table-templates"
        @selection-change="onSelectionChange"
        @row-click="rowClickTemplates"
      />
    </b-row>
  </b-container>
</template>

<script>
// https://github.com/TheoXiong/vue-table-dynamic
import InputDataTemplate from './templates/InputDataTemplate'
import VueTableDynamic from 'vue-table-dynamic'
import { mapGetters, mapActions } from 'vuex'
import ReportInfo from '@/functions/ReportInfo.js'
import { homogenizeReport } from '@/common/sharedDefinitions/reportDefinitions'

const zoneNotif = 'Tools Template'
const contextHelpLayoutTable = 'ReportViewer/Templates/Table'

export default {
    name: 'ToolsLayoutSection',
    components: {
        VueTableDynamic,
        InputDataTemplate,
    },
    data() {
        return {
            paramsTable: {
                data: [['Id', 'Name', 'Type']],
                header: 'row',
                border: true,
                stripe: true,
                sort: [0, 1, 2],
                pagination: true,
                showCheck: true,
                pageSize: 10,
                pageSizes: [10],
                columnWidth: [{ column: 0, width: '15%' }, { column: 1, width: '50%' }],
                enableSearch: true,
            },
            inputDataType: '',
            multipSelVisible: false,
            singleSelVisible: false,
            elementEditionId: -1,
            idTemplateDict: {},
            isLoading: false,
            newTemplate: {}
        }
    },
    computed: mapGetters(['getCurrentClusterNavigation', 'getNewTemplateMiddleware', 'getNameCurrProjectNavigation', 'getLastErrorMiddleware', 'getTemplateDBMiddleware', 'getCurrentReportViewer', 'getTemplListMiddleware', 'getProjTemplListMiddleware', 'getUpdatedValueTemplatesReportViewer']),

    methods: {
        ...mapActions([
          'removeTemplatesMiddlware',
          'setMessageVisibleReportViewer',
          'setMessageTextReportViewer',
          'setConfigReportModifiedReportViewer',
          'requestTemplateListMiddleware',
          'requestSingleTemplateMiddlware',
          'requestMultipleTemplatesFileMiddlware',
          'setContextOnHover',
          'setSaveLayoutReportViewer',
        ]),
        async updateTable(forced = false) {
            this.isLoading = true
            if (forced || this.getCurrentReportViewer.projectId !== this.getProjTemplListMiddleware) {//Get the list fromt the middlware if forced or the project is different
                const success = await this.requestTemplateListMiddleware({
                    clusterId: this.getCurrentClusterNavigation,
                    projectId: this.getCurrentReportViewer.projectId,
                })
                if (!success) {
                    const errText = 'Error requesting the templates from the server, please try in a few minutes. Error: ' + this.getLastErrorMiddleware
                    const errTitle = 'Error in Server'
                    this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotif)
                    this.isLoading = false
                    return
                }
            }
            this.idTemplateDict = {}
            const listTemplates = this.getTemplListMiddleware.sort((a, b) => a.shortId < b.shortId ? 1 : -1)
            this.paramsTable.data = [['Id', 'Name', 'Type']]
            for (let j = 0; j < listTemplates.length; j++) {
                const template = listTemplates[j]
                this.idTemplateDict[listTemplates.length - j] = template.id
                this.paramsTable.data.push([
                    listTemplates.length - j,
                    template.templateName,
                    template.templateType
                ])
            }
            this.isLoading = false
        },
        async rowClickTemplates(row) {
            this.isLoading = true;
              try {
                await this.$confirm(
                    `Do you want to apply the template '${this.paramsTable.data[row][1]}' to the current report?`,
                    'Apply template',
                    'question',
                    {
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                    }
                );
              }catch{
                this.loading = false
                return
              }
            try {
                const reportObjt = this.getCurrentReportViewer
                const success = await this.requestSingleTemplateMiddlware({
                    clusterId: this.getCurrentClusterNavigation,
                    projectId: reportObjt.projectId,
                    templateId: this.idTemplateDict[this.paramsTable.data[row][0]],
                })
                if (!success) {
                    const errText = 'Error sending the information to the server, please try in a few minutes. Error: ' + this.getLastErrorMiddleware
                    const errTitle = 'Error in Server'
                    this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotif)
                    return
                }
                const template = this.getTemplateDBMiddleware//Read the report obtained
                ReportInfo.applyTemplate(reportObjt, template)
                homogenizeReport(this, reportObjt)
                this.setConfigReportModifiedReportViewer()
                this.$emit('reportDeepChange')
                this.setSaveLayoutReportViewer(true)//Set the flag to save the layout off
            } catch(e) {
                console.error(e)
                const errText = 'Error applying the template. Error: ' + e
                const errTitle = 'Error in template'
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotif)
            }finally{
                this.isLoading = false;
            }
        },
        onSelectionChange(checkedDatas, checkedIndexs, checkedNum) {
            if (checkedIndexs.includes(0)) {
                checkedNum--
            }
            this.multipSelVisible = checkedNum >= 1
            this.singleSelVisible = checkedNum == 1
        },
        async exportSelected() {
            try {
                const selectedRows = this.$refs.tableTemplates.getCheckedRowDatas()
                const templates = []
                selectedRows.forEach(row => templates.push({
                    id: this.idTemplateDict[row[0]],
                    name: row[1]
                }))
                const success = await this.requestMultipleTemplatesFileMiddlware({
                    projectId: this.getCurrentReportViewer.projectId,
                    templates: templates,
                })
                if (!success) {
                    const errText = 'Error sending the information to the server, please contact the administrator of the system.'
                    const errTitle = 'Error in Server'
                    this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotif)
                }
            } catch (error) {

                const errText = 'Error sending the information to the server, please try in a few minutes.'
                const errTitle = 'Error in Server'
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotif)
            }
        },
        editSelected() {
            const selectedRows = this.$refs.tableTemplates.getCheckedRowDatas()
            const rowIdShort = selectedRows[0][0]
            const index = this.paramsTable.data.findIndex(row => row[0] === rowIdShort);
            if (index === -1) {
                const errText = `Error setting the template '${selectedRows[0][1]}' to edition. Please contact the administrator of the system.`
                const errTitle = 'Error in Server'
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotif)
            }
            this.elementEditionId = index
            this.inputDataType = 'edit'
        },
        async removeSelected() {
            try {
                const selectedRows = this.$refs.tableTemplates.getCheckedRowDatas()
                const templates = []
                selectedRows.forEach(row => templates.push({
                    id: this.idTemplateDict[row[0]],
                    name: row[1]
                }))
                this.setMessageVisibleReportViewer(true)
                const removeElements = []
                for (let j = 0; j < templates.length; j++) {
                    this.setMessageTextReportViewer(`Removing template '${templates[j].name}'...`)
                    const success = await this.removeTemplatesMiddlware({
                        clusterId: this.getCurrentClusterNavigation,
                        projectId: this.getCurrentReportViewer.projectId,
                        templateId: templates[j].id,
                    })
                    if (success) {
                        removeElements.push(templates[j].id)
                    } else {
                        const errText = `Error removing the template '${templates[j].name}'. Error: ${this.getLastErrorMiddleware}`
                        const errTitle = 'Error in Server'
                        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotif)
                    }
                }
                removeElements.forEach(rowId => {
                    const index = this.paramsTable.data.findIndex(row => this.idTemplateDict[row[0]] === rowId);
                    if (index !== -1) {
                        this.paramsTable.data.splice(index, 1);
                    }
                })
            } catch (error) {

                const errText = 'Error removing the selected templates. Please try in a few minutes.'
                const errTitle = 'Error in Server'
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotif)
            } finally {
                this.setMessageVisibleReportViewer(false)
            }
        },
        addNewTemplate() {
            this.inputDataType = 'add'
        },
        addLastTemplate() {
            this.inputDataType = ''
            if (this.getNewTemplateMiddleware === null) {
                return
            }
            this.getTemplListMiddleware.push(this.getNewTemplateMiddleware)
            this.updateTable()
        },
        addImportTemplate() {
            this.inputDataType = ''
            this.newTemplate = {}
            if (this.getNewTemplateMiddleware === null) {
                return
            }
            this.getTemplListMiddleware.push(this.getNewTemplateMiddleware)
            this.updateTable()
        },
        updateTemplate() {
            this.inputDataType = ''
            this.newTemplate = {}
            const newVal = this.getUpdatedValueTemplatesReportViewer
            const elementUpdate = this.getTemplListMiddleware[newVal.index - 1]
            elementUpdate.templateName = newVal.name
            elementUpdate.templateType = newVal.type
            this.updateTable()
        },
        async importTemplates(e) {
            const selectedFiles = e.target.files
            if (selectedFiles.length === 0) {
                return
            }
            const fileText = await this.readFileAsText(selectedFiles[0])
            try {
                this.newTemplate = JSON.parse(fileText);
            } catch (e) {

                this.newTemplate = {}
                const errText = 'Error importing the selected template. Please verify the file, it could be corrupted.'
                const errTitle = 'Error importing'
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, zoneNotif)
            }
            this.inputDataType = 'import'
        },
        async readFileAsText(file) {
            const result_base64 = await new Promise((resolve) => {
                const fileReader = new FileReader();
                fileReader.onload = () => resolve(fileReader.result);
                fileReader.readAsText(file);
            });

            return result_base64;
        },
        hideInput() {
            this.inputDataType = ''
        },
        onHoverTable() {
            this.setContextOnHover(contextHelpLayoutTable)
        },
        onLeave() {
            this.setContextOnHover(null)
        }
    }
}
</script>

<style lang="scss" scoped>
.title-template {
    color: #388A32;
    border-bottom: 2px solid #388A32;
    font-weight: 600;
    font-size: 1.25rem;
}

.table-templates {
    cursor: pointer;
}

.header-layout {
    align-items: center;
    background-color: var(--white);
    box-shadow: 0px 4px 12px #0000000a;
    display: flex;
    height: 3rem !important;
    opacity: 0.96;
    position: relative !important;
    z-index: 999;
    width: 100% !important;
    justify-content: space-around !important;


}
</style>
